// src/api.js
import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASE || "http://localhost:5000/api";

let authToken = null;
let onUnauthorized = null;
let redirecting = false;

export function setAuthToken(token) {
  authToken = token;
}

// Call this once from your App (so api.js doesn’t import react-router)
export function setUnauthorizedHandler(handler) {
  onUnauthorized = handler;
}

const api = axios.create({
  baseURL: API_BASE,
});

api.interceptors.request.use((config) => {
  if (authToken) {
    config.headers.Authorization = `Bearer ${authToken}`;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err?.response?.status;

    // A "must change password" 403 isn't an auth failure: the user is logged in
    // and belongs on the change-password screen, where background calls (e.g.
    // the unread-message poll) legitimately 403. Logging them out here was what
    // bounced them back to login a split second after the form appeared.
    if (status === 403 && err?.response?.data?.code === "password_change_required") {
      return Promise.reject(err);
    }

    if ((status === 401 || status === 403) && !redirecting) {
      redirecting = true;

      // clear token in memory
      setAuthToken(null);

      // clear stored auth (key used by AuthContext)
      localStorage.removeItem("hhh_auth");

      // tell the app to go to login
      if (typeof onUnauthorized === "function") {
        onUnauthorized();
      } else {
        // fallback if handler not set
        const next = window.location.pathname + window.location.search;
        window.location.assign(`/login?next=${encodeURIComponent(next)}`);
      }

      setTimeout(() => (redirecting = false), 500);
    }

    return Promise.reject(err);
  }
);

export default api;